// extracted by mini-css-extract-plugin
export var active = "_mi-2";
export var recordingDot = "_mi-1";
export var recordingIndicator = "_mi-0";